import React from "react";
import PropTypes from "prop-types";
import { DynamicHtml } from "@/ui";
import classes from "./styles.module.scss";
import clsx from "classnames";

/**
 *
 * @param className
 * @param description
 * @param tag
 * @returns {React.DetailedReactHTMLElement<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>|JSX.Element|null}
 * @constructor
 */
export default function Description({ className, description, tag }) {
  if (!description) {
    return null;
  }

  if (typeof description === "string") {
    return React.createElement(tag, {
      className: clsx(classes.description, className),
      dangerouslySetInnerHTML: { __html: description },
    });
  }

  return (
    <DynamicHtml className={clsx(classes.description, className)} path={description.path} tag={tag}>
      <span dangerouslySetInnerHTML={{ __html: description.placeholder }} />
    </DynamicHtml>
  );
}

Description.defaultProps = {
  className: "",
  description: null,
  tag: "div",
};

Description.propTypes = {
  className: PropTypes.string,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      path: PropTypes.string,
      placeholder: PropTypes.string,
    }),
  ]),
  tag: PropTypes.oneOf(["div", "span", "detail", "blockquote"]),
};
